export { JiraSoftwareIcon } from './icon';
export { JiraSoftwareLogo } from './logo';
